import axios from "axios";
import {materialCloudServicesPath} from "../../../Constants";

const jobRestUrl = materialCloudServicesPath+ '/user/job-metric-cut-material'

export default class JobMetricCutting {

    static async getJobMetricCuttingByMaterialId(materialId) {
        return axios.get(jobRestUrl + '/by-material-id-for-catalog'
            + '?materialId=' + materialId);
    }
}